import React from "react";
import Navbar from "../components/Navbar";
// import { Helmet } from "react-helmet";
import { graphql, Link } from "gatsby";

type Album = {
  Title: string;
  Price: number;
  url: string;
};

const AlbumsPage: React.FC<{ data: any }> = ({ data }) => {
  const { allStrapiAlbum } = data;
  const Albums: Album[] = allStrapiAlbum.edges.map(
    (edge: any) => edge.node as Album
  );
  console.log(Albums);

  function createAlbumChoices() {
    return Albums.map((album, index) => (
      <div key={index}>
        <Link to={album.url}>
          "{album.url}" {album.Title} <span>{album.Price}$</span>
        </Link>
      </div>
    ));
  }

  return (
    <div className="p-4">
      <Navbar />
      <div>AlbumPage</div>
      <div>{createAlbumChoices()}</div>
    </div>
  );
};

export default AlbumsPage;

export const pageQuery = graphql`
  query Albums {
    allStrapiAlbum {
      edges {
        node {
          Title
          Price
          url
        }
      }
    }
  }
`;
